import React from 'react';

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Collapse from '@material-ui/core/Collapse';
import customColor from '../CustomizedUIs/Colors'
import { Box, Typography, makeStyles, useTheme } from '@material-ui/core';
import icArrow from '../assets/icons/ic_angle_down.png';

import classNames from 'classnames';


const useStyles = makeStyles(theme => ({
    listItem: {
        paddingLeft: 16,
        paddingRight: 25,
        position: 'relative',
        zIndex: 3,
        height: 50
    },
    listItemOpening: {
        // backgroundColor: '#437091',
        WebkitBoxShadow: 'inset 0px 13px 10px -10px rgba(255,255,255,0.2)',
        MozBoxShadow: 'inset 0px 13px 10px -10px rgba(255,255,255,0.2)',
        boxShadow: ' inset 0px 13px 10px -10px rgba(255,255,255,0.2)',
        borderBottom: 'solid 1px rgba(255, 255, 255, 0.1)',
        borderLeft: '4px solid white',
    },
    listItemIcon: {
        minWidth: 0,
        marginRight: 20
    },
    listItemText: {
        fontFamily: 'UniviaPro',
        fontSize: '12px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        color: '#ffffff',

    },
    arrowIcon: {
        width: 12
    },
    arrowIconUp: {
        width: 12,
        transform: 'rotate(180deg)'
    }
}));

export default function SubMenu({ children, name, open, handleClick }: any) {
    const classes = useStyles();
    const arrowClass = open ? classes.arrowIconUp : classes.arrowIcon;
    const listItemStyles = open ? classNames(classes.listItem, classes.listItemOpening) : classes.listItem;
    const theme: any = useTheme()

    return (
        <Box borderBottom={1} bgcolor={theme.menu.color.item} style={{ borderBottomColor: 'rgb(255, 255, 255,0.1)' }}>
            <ListItem button onClick={handleClick} className={listItemStyles}>
                <ListItemText primary={<Typography variant='body1' className={classes.listItemText}>{name}</Typography>} />
                <img src={icArrow} className={arrowClass} />
            </ListItem>
            <Collapse in={open} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                    {children}
                </List>
            </Collapse>
        </Box>
    );
}
